import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { EnvironmentsPage } from 'features/subscriptionSettings'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/environments')({
  component: EnvironmentsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Environments'),
      },
    ],
  }),
  beforeLoad: protectWithWorkspacePermissions(canViewConfigurationPermission),
})
